import { h } from 'vue';
import { RouterLink } from 'vue-router';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { Button, Tag } from 'ant-design-vue';
import { getStatusColor } from '@/utility/statusColorUtils';

// Helper function to compute all flags related to item permissions and status
export function getItemFlags(item, profile, filters, checkPermission, handleDeleteRealisasi) {
  const isAbleDeleteRealisasi =
    checkPermission('delete realisasi kpi korporat') && item.realisasi && item.realisasi_status != 'REL';
  const isAbleUpdateRealisasi =
    checkPermission('update realisasi kpi korporat') && item.realisasi && item.realisasi_status != 'REL';
  const isAbleCreateRealisasi = checkPermission('create realisasi kpi korporat') && item.target && !item.realisasi;
  const isPengurang = item.jenis_variable_kpi_id == 3;
  const isCurrentLogin = profile.entitas_id === filters.entitas;
  const isNKO = item.name == 'NKO';
  const isButtonCreate = (isAbleCreateRealisasi && isCurrentLogin) || (isPengurang && !item.nilai);
  const isButtonUpdate =
    (isAbleUpdateRealisasi && isCurrentLogin) || (isPengurang && item.nilai && item.realisasi_status != 'REL');
  const isButtonDelete =
    (isAbleDeleteRealisasi && isCurrentLogin) || (isPengurang && item.nilai && item.realisasi_status != 'REL');
  const deleteButton = h(Button, {
    shape: 'circle',
    icon: h(DeleteOutlined),
    size: 'small',
    style: 'background-color: transparent; border: none; color: #555',
    onClick: () => handleDeleteRealisasi(item.realisasi_id, item.name, filters.bulan, filters.tahun),
  });

  const updateButton = h(
    RouterLink,
    {
      to: `/nko-rekap-edit-realisasi/${item.realisasi_id}`,
    },
    {
      default: () =>
        h(Button, {
          shape: 'circle',
          icon: h(EditOutlined),
          size: 'small',
          style: 'background-color: transparent; border: none; color: #555',
        }),
    },
  );

  const createButton = h(
    RouterLink,
    {
      to: `/nko-rekap-add-realisasi/${item.kpi_id}/${filters.bulan}/${filters.tahun}`,
    },
    {
      default: () =>
        h(Button, {
          shape: 'circle',
          icon: h(PlusOutlined),
          size: 'small',
          style: 'background-color: transparent; border: none; color: #555',
        }),
    },
  );

  const realisasiStatus = item.realisasi_status
    ? h(Tag, { color: getStatusColor(item.realisasi_status) }, [item.realisasi_status])
    : null;

  const del = isButtonDelete ? deleteButton : null;
  const updateRealisasi = isButtonUpdate ? updateButton : null;
  const createRealisasi = isButtonCreate ? createButton : null;

  return {
    isAbleDeleteRealisasi,
    isAbleUpdateRealisasi,
    isAbleCreateRealisasi,
    isPengurang,
    isCurrentLogin,
    isNKO,
    isButtonCreate,
    isButtonUpdate,
    isButtonDelete,
    createRealisasi,
    updateRealisasi,
    del,
    realisasiStatus,
  };
}
